<template>
  <div style="width: 100%">

    <!--图片轮播-->
    <div class="pictureRoll">
      <Carousel autoplay :autoplay-speed="playSpeed">
        <Carousel-item>
          <img src="../assets/home3.jpg" alt="" class="rollPic">
        </Carousel-item>
        <Carousel-item>
          <img src="../assets/home1.jpg" alt="" class="rollPic">
        </Carousel-item>
        <Carousel-item>
          <img src="../assets/home2.jpg" alt="" class="rollPic">
        </Carousel-item>
      </Carousel>
    </div>

    <!--轮播图片上的内容-->
    <div class="imgTop">
      <p class="title1">无障碍科技有限公司</p>
      <p class="title2">Change The World Of Visually Impaired</p>
      <p class="title3">操作系统+人工智能+志愿者</p>
      <Button class="btn" @click.native="learnMore">了解更多</Button>
    </div>

    <!--产品展示-->
    <div class="productShowBg">
      <!--产品展示标题-->
      <div class="showTitle">
        <p class="showP1" style="padding-top:6%;">产品展示</p>
      </div>
      <!--软件产品展示-->
      <div class="software">
        <div>
          <p style="font-size: 1.1rem;margin: 1% 1% 1% 4%;display: inline-block;color:rgba(0, 171, 169, 1);">—&nbsp;软件&nbsp;—</p>
          <Button type="text" style="display: inline-block;float: right;margin:1% 3% 2% 0;color:rgba(0, 171, 169, 1);"
                  @click.native="toProductPage">更多
            <Icon type="ios-more"/>
          </Button>
          <hr style="border-bottom:1px solid rgba(23, 219, 244, 1) ;border-top:none;"/>
        </div>
        <Row style="text-align: center;margin:3%">
          <Col :xs="24" :sm="12" :md="8" :lg="6"
               v-for="(value,index) in software" :key="index"
               @click.native="toProductionShow(value.productId)"
               class="goods">
          <Row>
            <Col>
            <img :src="value.appLogo" alt="" class="softwarePic"></Col></Row>
          <Row>
            <Col>
            <p class="softwareP">{{value.productTitle}}</p></Col></Row>
            <br>
            <br>
          </Col>
        </Row>
      </div>
      <!--硬件产品展示,class标签延用软件产品-->
      <!--<div class="software">
        <div>
          <p style="font-size: 1.1rem;margin: 1% 1% 1% 4%;display: inline-block;color: rgba(0, 171, 169, 1);">—&nbsp;硬件&nbsp;—</p>
          <Button type="text" style="display: inline-block;float: right;margin:1% 3% 2% 0;color: rgba(0, 171, 169, 1);"
                  @click.native="toHardGoods">
            更多
            <Icon type="ios-more"/>
          </Button>
          <hr style="border-bottom:1px solid rgba(23, 219, 244, 1) ;border-top:none;"/>
        </div>
        <Row style="text-align: center;margin:3%">
          <Col :xs="24" :sm="12" :md="8" :lg="6"
               v-for="(value,index) in hardware" :key="index"
               @click.native="toHardGoods(value.productId)"
               class="goods">
          <Row>
            <Col>
            <img :src="value.posterSrc" alt="" class="softwarePic"></Col></Row>
          <Row>
            <Col>
            <p class="softwareP" style="margin-bottom: 20px;">{{value.productTitle}}</p></Col></Row>
          </Col>
        </Row>
      </div>-->
    </div>


    <!--关于我们标题:class延用产品展示标题-->
    <div class="showTitle">
      <p class="showP1">关于我们</p>
    </div>

    <!--关于我们详细-->
    <div class="aboutUs">
      <Row style="text-align: center;margin:3%;">
        <Col :xs="24" :sm="24" :md="24" :lg="12">
        <Row><Col><p class="title">无障碍科技有限公司</p></Col></Row>
        <Row>
          <Col><p class="info">
          无障碍科技有限公司是一家社会创新型的企业，主要有华中科技大学的硕士组
          成，专注于无障碍领域产品的研究多年，致力于打破打破“数字鸿沟”，具有丰富研究
          技术成果。目前致力于启明导盲系列产品的研发、生产和销售，已经初步搭建了一套盲
          人生活娱乐学习交流沟通出行的系统级别的产品，公司致力于做最高效、最有性价比的
          导盲系统，以适中的价格为盲人群体提供高端服务，启明系列产品于软件、硬件、互联
          网服务三种形式逐层深入解决盲人获取信息和日常出行的问题，致力于为盲人开启一个
          新的“视”界，让盲人像明眼人一样平等快捷方便的使用智能手机和无障碍的出行。
        </p></Col>
        </Row>
        <Row><Col style="float:left;margin: 2% 0;width: 90%">
          <Button type="info"
                  class="btn"
                  size="large"
                  @click.native="learnMore">了解更多
          </Button></Col></Row>
        </Col>
        <Col :xs="24" :sm="24" :md="24" :lg="12">
        <img src="../assets/aboutUs.jpg" alt="" style="width:110%;height: 400px;margin-bottom: -5px">
        </Col>
      </Row>
    </div>

    <!--我们的荣誉标题:class延用产品展示标题-->
    <div class="showTitle" style="margin-top: 5%;">
      <p class="showP1">我们的荣誉</p>
    </div>

    <!--我们的荣誉-->
    <div class="aboutUs" style="display: flex; justify-content: space-between">
      <div style="width: 50%">
        <img src="../assets/ourhonor.jpg" alt="" style="width:100%;height: 100%;">
      </div>
      <ul class="honourList">
        <li class="honourItem">2019年08月&emsp;湖北省互联网+比赛红色之旅决赛奖金</li>
        <li class="honourItem">2019年07月  湖北省大学生创业大赛前十强 创业之星</li>
        <li class="honourItem">2019年05月&emsp;武汉江夏双创周创新创业 一等奖</li>
        <li class="honourItem">2019年05月&emsp;社创之星湖北省优胜奖第二名</li>
        <li class="honourItem">2018年10月&emsp;2018年网易中国创业家大赛武汉赛区亚军</li>
        <li class="honourItem">2018年07月&emsp;中美创客大赛（华中赛区） 一等奖</li>
        <li class="honourItem">2017年12月&emsp;获得第九届河南省青年软件创新创业大赛特等奖</li>
        <li class="honourItem">2016年12月&emsp;获得第三届全国高校移动互联网应用开发创新大赛一等奖</li>
        <li class="honourItem">2016年01月&emsp;获得腾讯优图首届高校创新大赛 银奖。</li>
        <li class="honourItem">2015年12月&emsp;获得IBM Bluemix开发者锦标赛 长跑比赛 认知计算一等奖。</li>
      </ul>
    </div>

    <!--我们的优势-->
    <div class="productShowBg">
      <!--我们的优势标题:class延用产品展示标题-->
      <div class="showTitle" style="padding-top:5%">
        <p class="showP1">我们的优势</p>
      </div>

      <!--我们的优势：详情-->
      <div class="advantage">
        <!--4个圆-->
        <Row style="text-align: center;margin:3%">
          <Col :xs="12" :sm="6" :md="6" :lg="6">
          <Row><img src="../assets/advantage1.png" alt="" class="circle"></Row>
          <Row style="color:rgba(13, 117, 116, 1);margin:5% auto;font-size: 1.0rem;">操作系统</Row>
          </Col>
          <Col :xs="12" :sm="6" :md="6" :lg="6">
          <Row><img src="../assets/advantage2.png" alt="" class="circle"></Row>
          <Row style="color:rgba(13, 117, 116, 1);margin:5% auto;font-size: 1.0rem;">AI</Row>
          </Col>
          <Col :xs="12" :sm="6" :md="6" :lg="6">
          <Row><img src="../assets/advantage3.png" alt="" class="circle"></Row>
          <Row style="color:rgba(13, 117, 116, 1);margin:5% auto;font-size: 1.0rem;">硬件</Row>
          </Col>
          <Col :xs="12" :sm="6" :md="6" :lg="6">
          <Row><img src="../assets/advantage4.png" alt="" class="circle"></Row>
          <Row style="color:rgba(13, 117, 116, 1);margin:5% auto;font-size: 1.0rem;">软件</Row>
          </Col>
        </Row>
        <!--文字详情-->
        <Row style="padding-bottom: 40px;">
          <Col><p style="text-align: justify;text-indent: 2em;color: rgba(13, 117, 116, 1);font-size: 1.0rem;width: 85%;margin: 0 auto;line-height: 1.8rem;">
          网明无障碍科技专注致力于消除“数字鸿沟”，掌握了全面的信息无障碍技术，目前研发的启明助盲产品借助图像和语音等相关的人工智能技术，在国际通用无障碍交
          互基础上首创的无障碍快捷交互模式，通过启明OS及配套APP（软件）、启明瞳系列导盲设备（硬件）、启明盲人智能服务平台（互联网服务）全方位多维度为盲人获
          取信息、交流沟通、日常出行、娱乐学习等需求提供帮助和服务。产品通过AI、志愿者、在线客服（残疾明眼人）等手段从文本、图片、视频三个维度来逐层深入解决
          盲人获取信息的问题。
        </p></Col>
        </Row>
      </div>
    </div>

    <!--页脚-->
    <div class="footer">
      <ul style="display: flex;align-items: center;flex-direction: column;list-style: none;justify-content: center; height: 100%">
        <li class="info">Copyright © 2017-2021 All rights reserved 版权所有 © 深圳启明无障碍科技有限公司</li>
        <li class="info">公司简介：启明无障碍科技专注智能信息辅具研发，致力于将AI、辅助功能技术与新人机交互整合起来改善失明、视力受损人士的生活。启明智能助盲产品借助AI、AR、辅助功能技术和实时视频技术研发的启明智能屏幕阅读器、瞳、听、行、店、圈、游等产品全方位多维度为中国1750视力残疾人和全球3.5亿低视力服务。</li>
        <li class="info">办公地址：广东省深圳市福田区梅林街道梅秀路2号</li>
        <li class="info">联系电话：18689481120</li>
        <li class="info"><a href="https://beian.miit.gov.cn/#/Integrated/recordQuery" style="color: white" target="_blank">工信部备案号：粤ICP备20026947号</a></li>
        <li class="info">公安备案号：粤公网安备44030002001389号</li>
      </ul>
    </div>
  </div>
  <!--</transition>-->
</template>

<script>
  export default {
    name: "home",
    data(){
      return{
        playSpeed:3000,
        goods:[
          /*软件*/
          "qimingEye",//启明瞳
          "qimingTrip",//启明出行
          "qimingFM",//启明FM
          "qimingOS",//启明OS
          /*硬件*/
          "qimingEyeHard",//启明瞳
          "qimingTripHard"//启明出行
        ],//软件与硬件id列表
        newslist:{},//一条新闻
        hardware:[],//硬件
        software:[]//软件
      }
    },
    methods:{
      learnMore(){
        this.$router.push('/contactUs');
      },//轮播图片上的了解更多
      toProductPage(){
        this.$router.push('/productionShow');
      },//跳转到产品展示页面
      toNews(){
        this.$router.push({
          path:'/newsDetail',
          query:{
            newsItem:this.newslist
          }
        });
      },//跳转到新闻详情页
      toProductionShow(value){
        this.$router.push({
          path:'/productionShow',
          query:{
            goodID:value
          }
        })
        console.log(value);
      },//点击产品跳转到产品展示页面，并定位到该产品
      toHardGoods(value){
        this.$router.push({
          path:'/community',
          query:{
            goodID:value
          }
        })
      },//跳转到硬件详情
      getSoftware(){
          this.software = [];
        this.$http.post('/zm/WMWebsite/queryProductInfos', {}).then(res=>{
          let count = 0;
          let tempList = res.data.content.productInfoArea1;
          for(let i = 0; i < tempList.length; i++){
              if(tempList[i].active === 1){
                  if(count < 4){
                      this.software.push(tempList[i]);
                      count++;
                  } else {
                      break;
                  }
              }
          }
        })
      },//获取软件信息：图片+名字
      /*getHardware(){
        this.$http.post('/zm/WMWebsite/queryProductInfos', {}).then(res=>{
          let i;
          let count=0;
          for(i=0;i<res.data.content.length,count<4;i++){
            if(res.data.content[i].appid!==""){
              this.software.push(res.data.content[i]);
              count++;
            }
          }
        })
      },//获取硬件信息：图片+名字：没有appid*/
      /*getNewsState(){
        this.$http.get('/zm/WMWebsite/queryNewsInfos').then(res=>{
          this.newslist=res.data.content[res.data.content.length-1];
        })
      }//获取新闻动态*/
    },
    created(){
      this.getSoftware();
      // this.getHardware();
      this.getNewsState();
    }
  }
</script>

<style scoped>
.rollPic{
  width: 100%;
  height: 600px;
}/*滚动的图片*/
.imgTop{
  position: absolute;
  top: 200px;
  right: 10%;
  z-index: 222;
}/*滚动图片里的内容*/
.imgTop .title1{
  color:white;
  font-size: 2.3rem;
  font-weight: bold;
}/*滚动图片里的字的第一行*/
.imgTop .title2{
  color:white;
  font-size:1.1rem;
}/*滚动图片里的字的第二行*/
.imgTop .title3{
  color:white;
  font-size:1.2rem;
  margin-top:3%;
}/*滚动图片里的字的第3行*/
.imgTop .btn{
  color: white;
  text-align: center;
  font-size: 1.3rem;
  margin-top: 10%;
  height:50px;
  background-color: rgba(4, 172, 172, 0.5);
  border:none;
}/*滚动图片里的了解更多按钮*/
.productShowBg{
  background-color: rgba(13, 117, 116, 0.1);
  margin-top: 50px;
}/*产品展示*/
.showTitle{
  margin:0 auto;
  width: 100%;
  text-align: center;
}/*产品展示标题*/
.showTitle .showP1{
  font-size:2.1rem;
  color:rgba(13, 117, 116, 1);
  font-weight: bold;
}
.showTitle .showP2 {
  font-size: 1.2rem;
  color: rgba(13, 117, 116, 1);;
  font-family: Microsoft YaHei;
}
.showTitle .showHr {
  width: 7rem;
  border-bottom:1px solid rgba(13, 117, 116, 1);;
  border-top:none;
  margin: 0 auto;
}
.software{

}/*软件产品展示*/
.software .softwarePic {
  width: 200px;
  height: 200px;
}/*软件产品展示里的图片*/
.software .softwareP{
  color:#000;
  font-weight: bold;
  font-size:1.4rem;
}/*软件产品展示里的文字*/
.aboutUs {
  width: 100%;
  /*height: 400px;*/
  background-color:rgba(69,193,192, 1);
}/*关于我们*/
.aboutUs .title{
  color: white;
  font-weight: bold;
  font-size:1.5rem;
  margin:5% 5% 5% 0;
}/*关于我们：简介标题*/
.aboutUs .info{
  color:white;
  width: 90%;
  text-indent: 2em;
  text-align: justify;
  font-size:1rem;
}/*关于我们，详情简介的文字*/
.aboutUs .btn{
  color: white;
  text-align: center;
  font-size: 1.3rem;
  width: 30%;
  height:50px;
  background-color: rgba(4, 172, 172, 0.5);
  border:none;
  margin-top:10px;
}
.honourList{
  width: 50%;
}/*我们的荣誉列表*/
.honourItem{
  color:white;
  margin:3%;
  font-size: 1.0rem;
  list-style:none;
}/*我们的荣誉项*/
.advantage .circle{
  /*background-color: rgba(57, 207, 204, 1);*/
  /*color: #fff;*/
  /*font-size: 1.4rem;*/
  /*text-align: center;*/
  width: 200px;
  height: 200px;
  /*border:10px solid rgba(57, 207, 204, 1);*/
  /*border-radius: 50%;*/
  /*line-height: 180px;*/
  /*margin:0 auto;*/
}/*我们的优势:四个圈*/
.advantage .info{
  text-indent: 2em;
  text-align: justify;
  color:rgba(80, 80, 80, 1);
  font-size:1rem;
  margin:2%;/*我们的优势，详情简介的文字*/
}/*我们的优势详情*/
.news .newsTitle{
  font-size: 1.2rem;
  color: rgba(13, 117, 116, 1);
  padding-top: 10px;
}/*新闻标题*/
.news .newsInfo{
  font-size: 1rem;
  color:rgba(13, 117, 116, 1);
  padding-left: 18px;
}
.footer{
  background-color: rgba(57, 207, 204, 1);
  text-align: center;
  width: 100%;
  height: 130px;
}/*页脚*/
.footer .info{
  color:#fff;
  font-size:0.8rem;
}/*页脚：里面的内容*/
.goods:hover{
cursor: pointer;
}/*移动到产品上时，鼠标形状*/

/*响应式*/
@media only screen/*手机竖屏*/
and (min-width: 320px)
and (max-width: 767px)
and (orientation: portrait){
  .rollPic{/*滚动的图片*/
    width: 100%;
    height: 250px;
    margin-top:1%;
  }
  .imgTop{/*滚动图片里的内容*/
    top: 28%;
    right: 10%;
  }
  .imgTop .title1{/*滚动图片里的字的第一行*/
    color:white;
    font-size: 1.1rem;
    font-weight: bold;
  }
  .imgTop .title2 {/*滚动图片里的字的第2行*/
    font-size: 0.9rem;
  }
  .imgTop .title3{
    font-size: 0.9rem;
  }
  .imgTop .btn{/*滚动图片里的了解更多按钮*/
    text-align: center;
    font-size: 1.1rem;
    margin-top: 10%;
    width: 40%;
    height:40px;
  }
  .advantage .circle{/*我们的优势:四个圈*/
    width: 150px;
    height: 150px;
    line-height: 140px;
  }
  .aboutUs img{
    margin-left: 0;
    padding-bottom: 10px;
  }
  .news .newsTitle{
    font-size: 0.8rem;
    padding-left: 0;
  }
  .news .newsInfo{
    font-size: 0.6rem;
    padding-left: 0;
  }
}
@media only screen/*手机横屏*/
and (min-width: 320px)
and (max-width: 767px)
and (orientation: landscape){
  .rollPic{/*滚动的图片*/
    width: 100%;
    height: 400px;
  }
  .imgTop{/*滚动图片里的内容*/
    top:200px;
    left:10%;
    text-align: center;
  }
  .showTitle .showP1{
    font-size:2.1rem;
    color:rgba(80, 80, 80, 1);
    font-weight: bold;
    margin-top: 10%;
  }
  .advantage .circle{/*我们的优势:四个圈*/
    width: 150px;
    height: 150px;
    line-height: 140px;
  }
  .aboutUs img{
    width: 100%;
    margin-left: 0;
  }
}
@media only screen/*平板竖屏*/
and (min-width: 768px)
and (max-width: 1024px)
and (orientation: portrait){
  .rollPic{/*滚动的图片*/
    width: 100%;
    height: 400px;
    margin-top:2%;
  }
  c{/*滚动图片里的内容*/
    top: 200px;
    right: 10%;
  }
  .rollPic{/*滚动的图片*/
    height: 400px;
  }
  .advantage .circle{/*我们的优势:四个圈*/
    width: 150px;
    height: 150px;
    line-height: 140px;
  }
}
@media only screen/*平板横屏*/
and (min-width: 768px)
and (max-width: 1024px)
and (orientation: landscape){
  .rollPic{/*滚动的图片*/
    width: 100%;
    height: 400px;
    margin-top:2%;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/home.vue